import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Onboarding = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'onboarding' */
  './Onboarding'
))

export function AsyncOnboarding(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Onboarding..." />}>
      <Onboarding {...props} />
    </Suspense>
  )
}

export default AsyncOnboarding
